import { createAction } from 'app-components/flux/core/actionHelpers';

export const getFeatureFlags = createAction(
  'GET_FEATURE_FLAGS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getFeatureFlagsSuccess = createAction(
  'GET_FEATURE_FLAGS_SUCCESS',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getFeatureFlagsFailure = createAction('GET_FEATURE_FLAGS_FAILURE');

export const applyFeatureFlagsChanges = createAction(
  'APPLY_FEATURE_FLAGS_CHANGES',
  (payload) => payload,
  (payload, metadata) => metadata,
);
